import { ColvenTheme, LINE_ACTIVE_STATE } from "./constants"
import { clone } from 'ramda'
import i18n from '@/i18n'
import { SCORING_SYSTEM } from '@colven/common-domain-lib/lib'

export const dialogTypes = {
    /**
     * Config para el diálogo de alta/modificación del ABM Things
     */
    THING: {
        key: 'THING',
        name: i18n.t('equipment.name'),
        content: {
            _uid: 'THING6Drn9e1',
            component: 'ThingDialogComponent',
            headline: 'ThingDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            description: null,
            typeId: null,
            gpsId: null,
            enterpriseId: null,
            currentActivity: null,
            harvestFrontId: null,
            fleetId: null,
            sectorId: null,
            groupId: null,
            identificator: null,
            color: '#0694de',
            features: null,
            hasOnBoardMonitor: null,
            originWorkWidth: null,
            config: {},
            boxQuantity: null,
            reminderBy: null,
            update: false,
            consumption: {},
            caliper: {},
            varilla: {},
            commodatum: false,
        }
    },

    GOALS: {
      
        key: 'GOALS',
        name: i18n.t('goals.name'),
        content: {
            _uid: 'GOALS6Drn9e1',
            component: 'GoalsDialogComponent',
            headline: 'GoalsDialogComponent'
        },
        model: {
                _id: null,
                name: null,
                description: null,
                enterpriseId: null,
                identificator: null,
                color: '#0694de',
                update: false,
                isSingleUpdate: false,
                selectedRowData: [],
                disabled: true
        }
        
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Modulo
     */
    MODULO: {
        key: 'MODULO',
        name: i18n.t('gps.name'),
        content: {
            _uid: 'MODULO6Drn9e1',
            component: 'GpsDialogComponent',
            headline: 'GpsDialogComponent'
        },
        model: {
            _id: null,
            unitId: null,
            brandId: null,
            modelId: null,
            stateId: null,
            buyDate: new Date().toISOString().substr(0, 10),
            firmware: null,
            serieNumber: null,
            line1: null,
            line1Number: null,
            line2: null,
            line2Number: null,
            description: null,
            communicationModuleId: null,
            update: false,
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Line
     */
    LINE: {
        key: 'LINE',
        name: i18n.t('line.name'),
        content: {
            _uid: 'LINE6Drn9e1',
            component: 'LineDialogComponent',
            headline: 'LineDialogComponent'
        },
        model: {
            _id: null,
            lineNumber: null,
            carrier: null,
            simCard: null,
            stateId: LINE_ACTIVE_STATE,
            roaming: false,
            description: null,
            update: false,
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Perfiles de Usuario
     */
    USER_PROFILES: {
        key: 'USER_PROFILES',
        name: i18n.t('userProfiles.name'),
        content: {
            _uid: 'SPJbOvCbZp',
            component: 'ProfileDialogComponent',
            headline: 'ProfileDialogComponent'
        },
        model: {
            _id: null, // id
            name: null, // nombre
            guest_user_profile: false, // perfil usuario invitado
            modules: [], // modulos del perfil,
            enterpriseId: null, // empresa del perfil
            enterprises: [], // arreglo de empresas para el selector (si es vacío, etnonces se intenta cargar en el dialog)
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Line
     */
    ENTERPRISE: {
        key: 'ENTERPRISE',
        name: i18n.t('enterprise.name'),
        content: {
            _uid: 'MeJf36POk6yJV_adQssw5c',
            component: 'EnterpriseDialogComponent',
            headline: 'EnterpriseDialogComponent'
        },
        model: {
            _id: null, // id
            name: null, // razón social
            address: null, // dirección
            phone: null, // teléfono
            countryId: null, // id del país
            provinceId: null, // id de la provincia
            cityId: null, // id de la localidad
            district: null, // partido
            cuit: null, // cuit
            fax: null, // fax
            // TODO: TENER EN CUENTA TIMEZONE DE LA EMPRESA CUANDO SE IMPLEMENTE
            customTimeSpan: { start: 3 }, // inicio de jornada
            email: null, // email
            suspended: false, // empresa suspendida
            additionalInformation1: null, // información adicional 1
            additionalInformation2: null, // información adicional 2
            themes: clone(ColvenTheme),
            logo: null, // logo
            loginLogo: null, // logo de la pantalla de login
            loginBackgroundImage: null, // imagen de fondo de la pantalla de login
            scoringConfiguration: {
                scoringSystem: SCORING_SYSTEM.ADDITION, // sistema de puntaje (resta - suma) -> CONSTANTES DEL COMMON DOMAIN
                additionMaxValue: null, // si el sistema de puntaje es suma, este valor tiene el valor tope, sino es null
                substractionInitialValue: null, // si el sistema de puntaje es resta, este valor tiene el valor mínimo, sino es null
                firstLevel: [],
                secondLevel: {
                    timeWindow: null,
                    hardBraking: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    acceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    corneringAcceleration: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    disconnection: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    }
                },
                thirdLevel: {
                    maxStopTime: null,
                    nightSchedule: {
                        start: null,
                        end: null
                    },
                    ralenti: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    continuousDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    nightDriving: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        }
                    },
                    incompleteRest: {
                        sligth: {
                            range: {
                                min: null,
                                max: null
                            },
                            weightedValue: null
                        },
                        medium: {
                            range: {
                                min: null,
                                max: null,
                            },
                            weightedValue: null
                        },
                        serious: {
                            range: {
                                min: 0,
                                max: null,
                            },
                            weightedValue: null
                        }
                    }
                }
            },
            menu: [],
            locales: {
                es: {},
                en: {},
                pt: {}
            },
            events: {},
            ruses: {},
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Group
     */
    GROUP: {
        key: 'GROUP',
        name: i18n.t('group.name'),
        content: {
            _uid: '9REBSWd3PL',
            component: 'GroupDialogComponent',
            headline: 'GroupDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            thingIds: [],
            things: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Flotas
     */
    FLEET: {
        key: 'FLEET',
        name: i18n.t('fleet.name'),
        content: {
            _uid: '9REBSWddfg',
            component: 'FleetDialogComponent',
            headline: 'FleetDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            thingIds: [],
            things: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Categorías
     */
    CATEGORY: {
        key: 'CATEGORY',
        name: i18n.t('category.name'),
        content: {
            _uid: 'CATEGORY6Drn9e1',
            component: 'CategoryDialogComponent',
            headline: 'CategoryDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterprises: [],
            enterpriseId: null,
            dataSelector: [],
            selectedZonePoiIds: [],
            color: null,
            logo: null,
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Flotas
     */
    WORK_FRONT: {
        key: 'WORK_FRONT',
        name: i18n.t('workFront.name'),
        content: {
            _uid: '9REBSWddfg',
            component: 'WorkFrontDialogComponent',
            headline: 'WorkFrontDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            thingIds: [],
            things: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Farm
     */
    FARM: {
        key: 'FARM',
        name: i18n.t('farm.name'),
        content: {
            _uid: '9REBSWd4TT',
            component: 'FarmDialogComponent',
            headline: 'FarmDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Ecological Unit
     */
    ECOLOGICAL_UNIT: {
        key: 'ECOLOGICAL_UNIT',
        name: i18n.t('ecologicalUnit.name'),
        content: {
            _uid: '9REBSW32BL',
            component: 'EcologicalUnitDialogComponent',
            headline: 'EcologicalUnitDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            farmId: null,
            farms: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Users
     */
    USER: {
        key: 'USER',
        name: i18n.t('user.name'),
        content: {
            _uid: 'IeVwMFamF6',
            component: 'UserDialogComponent',
            headline: 'UserDialogComponent'
        },
        model: {
            _id: null,
            username: null,
            fastAccess: false,
            comment: null,
            firstName: null,
            lastName: null,
            password: null,
            repeatPassword: null,
            email: null,
            enabled: true,
            dateRestriction: false,
            sinceDate: null,
            toDate: null,
            insideUser: false,
            remoteAccess: false,
            modifyPasswordNextLogIn: false,
            passwordExpiration: false,
            passwordExpirationDays: 0,
            inactivityDisconnection: false,
            authorizedIpRange: false,
            ipRangeFrom: null,
            ipRangeTo: null,
            userThings: [],
            userEnterprises: [],
            userGroups: [],
            profileId: null,
            enterprises: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de alta/modificación del ABM Persons
     */
    PERSON: {
        key: 'PERSON',
        name: i18n.t('person.name'),
        content: {
            _uid: 'rSnvDAbMgo',
            component: 'PersonDialogComponent',
            headline: 'PersonDialogComponent'
        },
        model: {
            _id: null,
            firstName: null,
            lastName: null,
            cuit: null,
            dni: null,
            dateOfBirth: null,
            civilStatus: null,
            address: null,
            cityId: null,
            district: null,
            provinceId: null,
            countryId: null,
            zipCode: null,
            phone1: null,
            phone2: null,
            whatsapp: null,
            sms: null,
            email1: null,
            email2: null,
            comment: null,
            driverCode: null,
            update: false
        }
    },

    HARVEST: {
        key: 'HARVEST',
        name: i18n.t('harvest.name'),
        content: {
            _uid: 'rSnvDAbMgo',
            component: 'HarvestDialogComponent',
            headline: 'HarvestDialogComponent'
        },
        model: {
            _id: null,
            name: null,
            enterpriseId: null,
            enterprises: [],
            thingIds: [],
            things: [],
            update: false
        }
    },

    /**
     * Config para el diálogo de condiguración de parámetros de scoring para cada empresa
     */
    SCORING: {
        key: 'SCORING',
        name: i18n.t('scoring.name'),
        content: {
            _uid: 'CQMY5XZgsb',
            component: 'ScoringDialogComponent',
            headline: 'ScoringDialogComponent'
        },
        model: {
            firstLevel: [],
            secondLevel: {
                timeWindow: null,
                hardBraking: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                acceleration: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                corneringAcceleration: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                disconnection: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
            },
            thirdLevel: {
                maxStopTime: null,
                nightSchedule: {
                    start: null,
                    end: null
                },
                ralenti: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                continuousDriving: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                nightDriving: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    }
                },
                incompleteRest: {
                    sligth: {
                        range: {
                            min: null,
                            max: null
                        },
                        weightedValue: null
                    },
                    medium: {
                        range: {
                            min: null,
                            max: null,
                        },
                        weightedValue: null
                    },
                    serious: {
                        range: {
                            min: 0,
                            max: null,
                        },
                        weightedValue: null
                    }
                }
            },
            update: false
        }
    },

    /**
     * Config para el diálogo de carga masiva del ABM Things
     */
    THING_MASSIVE_UPLOAD: {
        key: 'THING_MASSIVE_UPLOAD',
        name: i18n.t('equipment.name'),
        content: {
            _uid: 'xUTAin00oW',
            component: 'MassiveUploadThingDialogComponent',
            headline: 'MassiveUploadThingDialogComponent'
        },
        model: {
            file: null
        }
    },

    /**
     * Config para el diálogo de configuración de ruses para cada empresa
     */
    RUSES: {
        key: 'RUSES',
        name: i18n.t('ruses.name'),
        content: {
            _uid: 'CQMY5XZgsf',
            component: 'RusConfigurationDialogComponent',
            headline: 'RusConfigurationDialogComponent'
        },
        model: {}
    },
    /**
     * Config para el diálogo de configuración de eventos y estados para cada empresa
     */
    EVENT_CONFIGURATION: {
        key: 'EVENT_CONFIGURATION',
        name: i18n.t('events.name'),
        content: {
            _uid: 'CQMY5XZgRTB',
            component: 'EventConfigurationDialogComponent',
            headline: 'EventConfigurationDialogComponent'
        },
        model: {}
    },
    /**
     * Config para el diálogo de alta de unidad de manejo
     */
    DRIVE_UNIT: {
        key: 'DRIVE_UNIT',
        name: i18n.t('driveUnit.name'),
        content: {
            _uid: 'DRIVE_UNITA2Fy7dH1an',
            component: 'DriveUnitDialogComponent',
            headline: 'DriveUnitDialogComponent'
        },
        model: {
            geometry: null,
            enterpriseId: null,
            Name: null,
            ecologicalUnitId: null,
            farmId: null,
            area: null,
            headWidth: null,
            variety: null,
            age: null,
            description: null,
            harvestSpeed: null,
            machineEfficiency: null,
            plantingWidth: null,
            nivelationWidth: null,
            visibility: null,
            distanceToMill: null,
            tchp: null,
            tch: null,
            TCHR: null,
            grooves: null,
            kgPerGroove: null,
            groovesPerHectare: null
        }
    },
    /**
     * Config para el diálogo del ABM de tipos de eventos
     */
    EVENT_TYPE: {
        key: 'EVENT_TYPE',
        name: i18n.t('eventType.name'),
        content: {
            _uid: 'MyR3GQnlex',
            component: 'EventTypeDialogComponent',
            headline: 'EventTypeDialogComponent'
        },
        model: {
            _id: null,
            name: {
                es: null,
                en: null,
                pt: null
            },
            color: '#ff0000',
            comment: null,
            enterprises: []
        }
    },
    /**
     * Config para el diálogo del ABM de tipos de estados
     */
    STATE_TYPE: {
        key: 'STATE_TYPE',
        name: i18n.t('stateType.name'),
        content: {
            _uid: 'MyR3GQnRCJ',
            component: 'StateTypeDialogComponent',
            headline: 'StateTypeDialogComponent'
        },
        model: {
            _id: null,
            name: {
                es: null,
                en: null,
                pt: null
            },
            color: '#ff0000',
            comment: null,
            enterprises: []
        }
    },
    /**
     * Config para el diálogo del ABM de eventos
     */
    EVENT: {
        key: 'EVENT',
        name: i18n.t('event.name'),
        content: {
            _uid: 'MyR3GQnsdl',
            component: 'EventDialogComponent',
            headline: 'EventDialogComponent'
        },
        model: {
            editingIndex: null,
            enterpriseId: null,
            eventNumber: null,
            eventType: null,
            eventName: {
                es: null,
                en: null,
                pt: null
            },
            eventColor: '#FF3333',
            stateType: null,
            stateName: {
                es: null,
                en: null,
                pt: null
            },
            stateColor: '#FF3333',
            eventNumbers: [],
            update: false
        }
    },

    SECTOR: {
        ket: 'SECTOR',
        name: i18n.t('sector.name'),
        content: {
            _uid: 'MyRfg8nsdl',
            component: 'SectorDialogComponent',
            headline: 'SectorDialogComponent'
        },
        model: {}
    },

    /**
     * Config para el diálogo de alta/modificación del ABM AlertEvent
     */
    ALERT_EVENT: {
        key: 'ALERT_EVENT',
        name: i18n.t('alertEvent.name'),
        content: {
            _uid: 'ALERT_EVENT6Drn9e1',
            component: 'AlertEventDialogComponent',
            headline: 'AlertEventDialogComponent'
        },
        model: {
            _id: null,
            thingIds: null,
            thingsData: null,
            userIds: null,
            usersData: null,
            eventIds: null,
            eventsData: null,
        }
    }
}
